// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__i93Am"};